<template>
  <div class="row">
    <div class="col-12">
    <card card-body-classes="table-full-width" no-footer-line>
      <div>
        <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.corporate_roles.new_corporate_rol.title") }}
            </h4>
          </div>
          <div class="col-12">
          <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submitNewCorpRole)">
            <h3>
              <small>{{ $t("app.general.translates") }}</small>
            </h3>
            <template>
              <div v-for="lang in item.langs" :key="lang.idLenguaje">
                <div class="row">
                  <div class="col-sm-6">
                    <ValidationProvider
                      name="minLength"
                      rules="required|min:5"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :placeholder="lang.idioma"
                        :error="
                          failed
                            ? 'La longitud mínima para el nombre es de 5 '
                            : null
                        "
                        :hasSuccess="passed"
                        name="minLength"
                        :label="
                          $t('app.modules.corporate_roles.new_corporate_rol.name')
                        "
                        v-model="lang.nombre"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="col-sm-6">
                    <ValidationProvider
                      name="minLength"
                      rules="required|min:5"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :placeholder="lang.idioma"
                        :error="
                          failed
                            ? 'La longitud mínima para el nombre es de 5 '
                            : null
                        "
                        :hasSuccess="passed"
                        name="minLength"
                        :label="
                          $t(
                            'app.modules.corporate_roles.new_corporate_rol.description'
                          )
                        "
                        v-model="lang.descripcion"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </template>
            <h3>
              <small>{{
                $t("app.modules.corporate_roles.new_corporate_rol.permission")
              }}</small>
            </h3>
            <!-- Módulos -->
            <div class="row table-full-width">
              <div class="col-sm-12">
                <el-table stripe :data="tableData">
                  <el-table-column
                    prop="titulo"
                    :label=" $t(
                            'app.modules.corporate_roles.new_corporate_rol.module'
                          )"
                    class="col-4"
                  >
                  </el-table-column>
                  <el-table-column
                  prop="nombreModulo"
                    :label=" $t(
                            'app.modules.corporate_roles.new_corporate_rol.permission'
                          )"
                    class="col-8"
                  >
                    <template slot-scope="scope" class="image-slot">
                      <n-checkbox
                        v-model="permiso.status"
                        v-for="permiso in scope.row.permisos"
                        :label="permiso.permiso"
                        :key="permiso.id_ClaimsModule">
                          {{permiso.permiso}}
                      </n-checkbox>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!--
              Aqui van los permisos de roles
            -->
            <div class="col-sm-6 form-group has-label">
              <div class="row">
                <label style="margin-left: 15px">{{
                  $t("app.general.active")
                }}</label>
              </div>
              <template>
                <n-switch v-model="item.activo">
                  <i class="now-ui-icons ui-1_check" slot="on"></i>
                  <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                </n-switch>
              </template>
            </div>

            <div
              slot="footer"
              style="margin-top: 10px; padding-top: 20px;border-top: outset;"
              class="text-right"
            >
              <router-link :to="{ name: 'Roles empresariales' }" class="col-2">
                <n-button class="pull-left btn-secondary">{{ $t("app.buttons.cancel") }}</n-button>
              </router-link>
              <n-button native-type="submit" type="primary">
                {{ $t("app.buttons.save") }}
              </n-button>
            </div>
          </form>
        </ValidationObserver>
          </div>
      </div>
    </card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      item: {
        idRol: 0,
        nombreRol: "",
        idEmpresa: 1,
        activo: true,
        externo: true
      },
      tableData: [],
      claimsModule: []
    };
  },
  computed: {
    ...mapState(["availableLangs"])
  },
  async created() {
    this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

    this.item.langs = this.availableLangs.map(lang => ({
      idioma_idIdioma: lang.idIdioma,
      idioma: lang.idioma,
      nombre: "",
      descripcion: ""
    }));

     await this.initPerfilEmpAdd();
      this.$swal.close();
  },
  mounted() {},
  methods: {
    createDate() {
      var date = new Date();
      var str =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
      return str;
    },
    async initPerfilEmpAdd() {
      await this.getModulesClaim()
    },
    async getModulesClaim(){
      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };
      await this.$http
        .post(route("ModuloRol/getClaimsModule"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.datatemp = response.body.modulosRoles.filter(
                r => r.externo
              );

              for (let modulo of this.datatemp) {

                let permisos = [];
                for(let permiso of modulo.claimsModule){
                  permisos.push(
                    {
                      id_ClaimsModule: permiso.id_ClaimsModule,
                      permiso: permiso.permiso,
                      status: false
                    }
                  )
                }

                this.tableData.push (
                {
                  idmodule: modulo.idModuloRol,
                  idRol: 0,
                  titulo: modulo.nombreModulo,
                  permisos: permisos
                }
                );


              };


            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async submitNewCorpRole() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.addNewCorpRole();
      this.$swal.close();
    },
    async addNewCorpRole() {
      var actualDate = this.createDate();
      this.item.nombreRol = this.item.langs[0].nombre;
      this.item.concurrencyStamp = actualDate;
      this.item.externo = true
      const param = {
        Id: 0,
        Name: this.item.nombreRol,
        NormalizedName: this.item.nombreRol,
        Active: this.item.activo,
        ConcurrencyStamp: this.item.concurrencyStamp,
        Externo: this.item.externo
      }
      console.log(this.item)
      console.log(param)
      // console.log(this.tableData)

      // Validar que no se tenga un rol con ese nombre
      let items = [];
      for (let lang of this.item.langs) {
        items.push({
          id: 0,
          name: lang.nombre
        });
      }
      const params = {
        edit: false,
        items: items
      }

      await this.$http
        .post(route("Roles/postExistRol"), params)
        .then(async (response) =>{
          if (response.body.code === 200) {
            if (response.body.exist) {
              this.notifyMessage("danger", this.$t("app.modules.corporate_roles.promp.existing_role"));
            } else {
              await this.$http
              .post(route("Roles/postAddRolePermiso"), param)
              .then(
                async response => {
                  if (response.body.code === 200){
                    this.item.nombreRol = this.item.langs[0].nombre;
                    console.log(response.body.id);

                    // update idRol
                    for(let e of this.tableData){
                      e.idRol = response.body.id;
                    }

                    // Hacer el siguiente post
                    for (let lang of this.item.langs) {
                      lang.idRolTraduccion = 0;
                      lang.fechaModificacion = actualDate;
                      lang.fechaCreacion = actualDate;
                      lang.roles_idRol = response.body.id;
                    }
                    for (let data of this.tableData) {
                      data.rolesIdRol = response.body.id;
                    }
                    var payload = {
                      id: response.body.id,
                      claveIdioma: this.$store.state.lang,
                      usuario: this.$store.state.user.idUsuario,
                      traducciones: this.item.langs

                    };
                    console.log("Antes de postRolTraduccion");
                    console.log(payload);
                    await this.$http
                      .post(route("Roles/postRolTraduccion"), payload)
                      .then(
                        async respo => {
                          console.log(respo);
                          if (respo.body.code === 200) {
                            console.log("Hizo postRolTraduccion");
                            //



                            var payload = {
                              claveIdioma: this.$store.state.lang,
                              usuario: this.$store.state.user.idUsuario,

                              moduloPermisos: this.tableData

                            };
                            await this.$http
                              .post(
                                route("Roles/postPermisosByRol"),
                                payload
                              )
                              .then(
                                async response => {
                                  console.log(response);
                                  if (response.body.code === 200) {
                                    this.notifyMessage(
                                      "success",
                                      this.$t("app.promps.save_success")
                                    );
                                    this.$router.push({ name: 'Roles empresariales' })
                                  } else {
                                    this.notifyMessage(
                                      "danger",
                                      this.$t("app.promps.error")
                                    );
                                  }
                                },
                                error => {
                                  this.notifyMessage(
                                    "danger",
                                    this.$t("app.promps.error")
                                  );
                                }
                              )
                              .finally(() => {});




                            //
                            payload = {};
                            for (let lang of this.item.langs) {
                              lang.idRolTraduccion = 0;
                              lang.fechaModificacion = "";
                              lang.fechaCreacion = "";
                              lang.roles_idRol = 0;
                              lang.descripcion = "";
                              lang.nombre = "";
                            }
                          } else {
                            this.notifyMessage("danger", this.$t("app.promps.error"));
                          }
                        },
                        error => {
                          this.notifyMessage("danger", this.$t("app.promps.error"));
                        }
                      )
                      .finally(() => {});
                    //
                  }
                  else {
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                  }
                },
                error => {
                  this.notifyMessage("danger", this.$t("app.promps.error"));
                }
              )
              .finally(() => {});
            }
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        });
    }
  }
};
</script>

<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}
</style>
